<div class="pages">
  <div data-page="blog" class="page no-toolbar no-navbar">
    <div class="page-content">

      <div class="navbarpages">
        <div class="navbar_left"><a [routerLink]="['/menu']"><img src="./assets/images/icons/blue/menu.png"
          alt=""
        title=""/></a></div>
        <div class="navbar_center"><h2>{{ this.Ueberschrift }}</h2></div>
        <div class="navbar_right">

        </div>
      </div>
      <div id="pages_maincontent">
        <br>
          @for (setting of settings ; track setting) {
            <div>
              @if (setting.anzeigen=='false' && setting.typ=='headline') {
                <div><br>
                  <div class="setting_group">
                    <div class="setting">
                      <div (click)="toggle(setting)">{{ setting.Ueberschrift }}
                        <i class="arrow right"></i>
                        <div>
                          <hr>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (setting.anzeigen=='true' && setting.typ=='headline') {
                  <div (click)="toggle(setting)"
                    class="setting_headline">{{ setting.Ueberschrift }}
                  </div>
                }
                @if (setting.anzeigen=='true' && setting.typ=='headline') {
                  <div class="setting_group" id="">
                    @for (set of settings; track set; let i = $index) {
                      <div class="setting">
                        @if (set.typ!='headline' && set.typ=='switch' && set.gruppe == setting.gruppe) {
                          <div>@if (set.beschreibung !== '') {
                            <img
                              (click)="opendialog(set);"
                              src="assets/images/icons/blue/information.png">
                              }  {{ set.Ueberschrift }}
                              @if (set.typ == 'switch') {
                                <ui-switch [checked]="set.value == 'true'"
                                  [disabled]="set.disabled == 'true'"
                                (change)="onchange(set.id,$event)"></ui-switch>
                              }
                              @if (settings[i+1]) {
                                <div>
                                  @if (settings[i+1].gruppe == set.gruppe) {
                                    <hr>
                                    }
                                  </div>
                                }
                              </div>
                            }
                            @if (set.typ!='headline' && set.typ=='input_number' && set.gruppe == setting.gruppe) {
                              <div>
                                @if (set.beschreibung !== '') {
                                  <img (click)="opendialog(set);"
                                    src="assets/images/icons/blue/information.png">
                                    }  {{ set.Ueberschrift }}
                                    <input type="number" [value]="set.value" (keyup)="onchange(set.id,$event.target.value)">
                                    @if (settings[i+1]) {
                                      <div>
                                        @if (settings[i+1].gruppe == set.gruppe) {
                                          <hr>
                                          }
                                        </div>
                                      }
                                    </div>
                                  }
                                  @if (set.typ!='headline' && set.typ=='action' && set.gruppe == setting.gruppe) {
                                    <div
                                      (click)="onaction(set.id,set.value)">{{ set.Ueberschrift }}
                                      <i class="arrow right"></i>
                                      @if (settings[i+1]) {
                                        <div>
                                          @if (settings[i+1].gruppe == set.gruppe) {
                                            <hr>
                                            }
                                          </div>
                                        }
                                      </div>
                                    }
                                    @if (set.typ!='headline' && set.typ=='text' && set.gruppe == setting.gruppe) {
                                      <div>{{
                                        set.Ueberschrift
                                        }}
                                        <span><u>{{ set.value }}</u></span>
                                        @if (settings[i+1]) {
                                          <div>
                                            @if (settings[i+1].gruppe == set.gruppe) {
                                              <hr>
                                              }
                                            </div>
                                          }
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          }

                        </div>
                      </div>
                    </div>
                  </div>
